import { render } from "./join-pieces.vue?vue&type=template&id=43102433&scoped=true"
import script from "./join-pieces.vue?vue&type=script&lang=js"
export * from "./join-pieces.vue?vue&type=script&lang=js"

import "./join-pieces.vue?vue&type=style&index=0&id=43102433&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43102433"]])

export default __exports__